import { generateConfig } from "./gs-utils/core/utils";
import { API_URL_CONFIG_TYPE } from "./gs-utils/core/types";

const {
  bot: domain,
  serviceUrl,
  homeUrl,
  developerUrl,
  apiGetway,
} = generateConfig() as API_URL_CONFIG_TYPE;

export const envConfig: Record<string, string> = {
  domain,
  apiGetway,
  serviceUrl,
  login: `${domain}/gas/api/v1alpha1/sso/login`,
  logout: `${domain}/gas/api/v1alpha1/sso/logout`,
  refreshToken: `${domain}/gas/api/v1alpha1/auth/token`,
  gas: "/gas/api/v1alpha1",
  homeUrl,
  developerUrl,
  env: process.env.REACT_APP_NODE_ENV || "",
  region: process.env.REACT_APP_REGION || "",
  lane: process.env.REACT_APP_LANE || "",
};
